// extracted by mini-css-extract-plugin
export default {"hand":"Pointing_hand__HY7e9","rotate":"Pointing_rotate__StaDc"};